import { Component, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'dac-pricing-table',
  templateUrl: './pricing-table.component.html',
  styleUrls: ['./pricing-table.component.scss']
})
export class PricingTableComponent implements OnInit {

  @Output() selected = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
  }

  selectPlan(type:string) {
    this.selected.next(type);
  }


}



// WEBPACK FOOTER //
// ./src/app/pricing-table/pricing-table.component.ts